import React, { useEffect, useRef, useState } from "react";
import { MoreHorizontal } from "lucide-react";
import "./OwnerActionsMenu.css";

/**
 * Discreet "…" menu for author-only edit/delete actions.
 */
function OwnerActionsMenu({ onEdit, onDelete, disabled = false, ariaLabel = "Mais opções" }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const onPointerDown = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const onKeyDown = (e) => {
      if (e.key === "Escape") setOpen(false);
    };

    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  if (!onEdit && !onDelete) return null;

  return (
    <div className="owner-actions" ref={rootRef}>
      <button
        type="button"
        className="owner-actions-trigger"
        aria-label={ariaLabel}
        aria-haspopup="menu"
        aria-expanded={open}
        disabled={disabled}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen((v) => !v);
        }}
      >
        <MoreHorizontal size={18} />
      </button>

      {open && (
        <div className="owner-actions-menu" role="menu">
          {onEdit && (
            <button
              type="button"
              role="menuitem"
              className="owner-actions-item"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setOpen(false);
                onEdit();
              }}
            >
              Editar
            </button>
          )}
          {onDelete && (
            <button
              type="button"
              role="menuitem"
              className="owner-actions-item owner-actions-item-danger"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setOpen(false);
                onDelete();
              }}
            >
              Excluir
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default OwnerActionsMenu;
